import { apiClient, ensureCsrfCookie } from '@/api/client'
import type { ApiSuccessResponse } from '@/types/api'

export interface Organization {
  id: number
  name: string
  legalName: string | null
  logoUrl: string | null
  website: string | null
  industry: string | null
  sizeRange: string | null
  description: string | null
  status: 'active' | 'inactive' | 'suspended'
  verifiedAt: string | null
  createdAt: string
}

async function withCsrf<T>(fn: () => Promise<T>): Promise<T> {
  await ensureCsrfCookie()
  return fn()
}

export const organizationApi = {
  get: async () => {
    const { data } =
      await apiClient.get<ApiSuccessResponse<Organization>>('/recruiter/organization')
    return data.data
  },

  update: (payload: Record<string, unknown>) =>
    withCsrf(async () => {
      const { data } = await apiClient.put<ApiSuccessResponse<Organization>>(
        '/recruiter/organization',
        payload,
      )
      return data.data
    }),

  uploadLogo: (file: File) =>
    withCsrf(async () => {
      const form = new FormData()
      form.append('logo', file)
      const { data } = await apiClient.post<ApiSuccessResponse<Organization>>(
        '/recruiter/organization/logo',
        form,
      )
      return data.data
    }),
}
